type ClassNameLike = string | undefined | null | false;

export function clsx(...names: ClassNameLike[]) {
  return names.filter(Boolean).join(" ");
}
